/**
 * Helpers dates tolérants (spec iter277 — crash « Invalid time value »).
 * `Date.prototype.toISOString()` lève une RangeError sur une date invalide
 * (ex. saisie datetime-local avec une année à 5 chiffres « 20260-… »).
 */
export function parseDateOrNull(value) {
  if (value === null || value === undefined || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function toIsoOrNull(value) {
  const d = parseDateOrNull(value);
  return d ? d.toISOString() : null;
}

/**
 * formatActivityShort — libellé compact d'activité, sans « il y a »
 * (spec iter265/278, colonnes « Activité » Documents & Tâches) :
 *   < 1 min → « à l'instant » · < 1 h → « 12 min » · < 24 h → « 18 h »
 *   < 7 j → « 2 j » · < 365 j → « 20 août » · au-delà → « 20 août 2025 ».
 */
export function formatActivityShort(iso, now = new Date()) {
  const d = parseDateOrNull(iso);
  if (!d) return "";
  const diffS = Math.max(0, Math.round((now - d) / 1000));
  if (diffS < 60) return "à l'instant";
  const diffM = Math.round(diffS / 60);
  if (diffM < 60) return `${diffM} min`;
  const diffH = Math.round(diffM / 60);
  if (diffH < 24) return `${diffH} h`;
  const diffD = Math.round(diffH / 24);
  if (diffD < 7) return `${diffD} j`;
  const opts = { day: "2-digit", month: "short" };
  if (diffD >= 365) opts.year = "numeric";
  return d.toLocaleDateString("fr-FR", opts).replace(/\.(\s|$)/, "$1");
}

/** Couleurs de la pastille « Activité » selon l'ancienneté. */
export function activityPillStyle(iso, now = Date.now()) {
  const d = parseDateOrNull(iso);
  const ageMs = d ? Math.max(0, now - d.getTime()) : Infinity;
  const oneHour = 60 * 60 * 1000;
  let bg = "#1e1e20", color = "#8a8a8f";
  if (ageMs < oneHour) { bg = "#1a2a1e"; color = "#5dcaa5"; }
  else if (ageMs < 24 * oneHour) { color = "#c8c8cc"; }
  return { background: bg, color, borderRadius: 12, padding: "3px 9px", fontSize: 11, lineHeight: 1.2, fontWeight: 500, display: "inline-block", maxWidth: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", verticalAlign: "middle" };
}
